// extracted by mini-css-extract-plugin
export default {"container":"Vso__","migrateButton":"SYFGt"};